import { MouseEvent, useEffect, useState } from "react";
import styles from "./MapListItem.module.css";
import { isDev, MapItem, MapUserActivity, MenusItem } from "./Common";
import UserActivityInfo from "./UserActivityInfo";
import Icon from "./Icon";
import MapKeywordItem from "../publicmap/MapKeywordItem";
import Menus from "./Menus";
import { BASE_URL, DEV_BASE_URL, HOME_URL } from "../../data_provider/Config";

/**
 * @author bakim
 * @date 2024-08-20 10:55:37
 * @remark 지도 목록 아이템
 * @param {MapItem} item: 맵 아이템 데이터 (required)
 * @param {boolean} isActive: 맵 아이템 메뉴 클릭 여부(required);
 * @param {MenusItem[]} menusItem: 맵 아이템 메뉴
 * @param onClickItem: 맵 아이템 클릭 이벤트 콜백함수 (required)
 * @param onClickMenus: 메뉴 클릭 이벤트 콜백함수
 * @returns MapListItem
 */

interface MapListItemProps {
    item: MapItem;
    isActive: boolean;
    menusItem?: MenusItem[];
    isPrivateMap?: boolean;
    onClickItem: (mapId: string) => void;
    onClickMenus?: (event: MouseEvent<HTMLElement>) => void;
    isMyMap?: boolean;
}

type MapImageItem ={
    iid: number;
    src: string;
}
type MapImageList = MapImageItem[];


const MapListItem = ({ item, ...props }: MapListItemProps) => {
    const [userActivity, setUserActivity] = useState<MapUserActivity>();

    useEffect(() => {
        const _userActivity = {
            viewCnt: item.viewCnt,
            bookmarkCnt: item.bookmarkCnt,
            thumbCnt: item.thumbCnt,
        };
        setUserActivity(_userActivity);
    }, [item]);

    const openMap = () => {
        props.onClickItem(item.mapId);
    };
    // mainImage -> images[0]으로 변경, images필드만 사용
    //const mainImgUrl = item.mainImage ? item.mainImage : `${isDev() ? DEV_BASE_URL : HOME_URL}/modoomap_image/thumbnail/${item.mapId}.png`;
    const parsedImages:MapImageList = item.images && typeof item.images === "string" ? JSON.parse(item.images) : item.images;
    const mainImgUrl = parsedImages.length>0? parsedImages[0].src : `${isDev() ? DEV_BASE_URL : HOME_URL}/modoomap_image/thumbnail/${item.mapId}.png`;
    
    return (
        <div className={`${styles.container} ${props.menusItem ? "" : styles.small} ${props.isActive ? styles.active : ""}`} onClick={openMap}>
            {/* <div className={`${styles.contents} ${item.mainImage && styles.info}`}> */}
            <div className={`${styles.contents} ${styles.info}`}>
                <div>
                    <div className={styles.header}>
                        <span className={`${styles.title} ${styles.text}`}>{item.title}</span>
                        <div className={styles.keywords}>
                            {item.keyword &&
                                typeof item.keyword === "string" &&
                                // 보안 취약점 방지를 위해 eval 대신 JSON.parse 사용
                               JSON.parse(item.keyword).map((keyword: string, index: number) => {
                                    return <MapKeywordItem title={keyword} size="xxsmall" key={`keyword_${index}`} />;
                                })}
                        </div>
                    </div>
                    <div className={styles.subHeader}>
                        <span className={styles.text}>{item.username}</span>
                        <span className={`${styles.date} ${styles.text}`}>{item.createDate}</span>
                        {props.isMyMap && (
                            <span className={`${styles.public} ${styles.text}`}>
                                <Icon
                                    name={props.isPrivateMap ? "lock" : "open_lock"}
                                    className={styles.lockIcon}
                                    color={props.isPrivateMap ? "red" : undefined}
                                    size="small"
                                    size2="medium"
                                />
                                <span className={`${styles.text}`} style={{ whiteSpace: 'pre' }}>
                                    {props.isPrivateMap ? "(비공개)" : "(공개)"}
                                </span>
                            </span>
                        )}
                        {/* {item.cacheDate ? 
                            <span className={`${styles.date} ${styles.text}`}>분석완료</span> 
                            : <span className={`${styles.date} ${styles.text}`}>분석중</span>} */}
                    </div>
                </div>
                <div className={styles.desc}>{item.description?.repeat(1)}</div>

                <div className={styles.footer}>
                    <UserActivityInfo size="small" count={userActivity?.bookmarkCnt ?? 0} type="bookmark" iconStyle={{ color: "default" }} />
                    <UserActivityInfo size="small" count={userActivity?.thumbCnt ?? 0} type="thumbUp" iconStyle={{ color: "green" }} />
                    <UserActivityInfo size="small" count={userActivity?.viewCnt ?? 0} type="view" iconStyle={{ color: "hotpink" }} />
                </div>
            </div>

            {/* mainImage가 없는 경우에는 지도 썸네일 뿌려주기 */}
            <div className={`${styles.contents} ${styles.media}`}>
                <img className={styles.image} src={mainImgUrl} />
            </div>

            {props.menusItem && (
                <div className={`${styles.button_container} mapListItemMenu`}>
                    <div className={styles.button} onClick={props.onClickMenus}>
                        <Icon name={"more"} color="grey" />
                    </div>
                    {props.isActive && <Menus options={props.menusItem} />}
                </div>
            )}
        </div>
    );
};

export default MapListItem;
